<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Factory' }">厂家列表</el-breadcrumb-item>
          <el-breadcrumb-item>新建厂家</el-breadcrumb-item>
        </el-breadcrumb>
    <el-row style="padding: 30px">
      <el-col :span="12" >
        <el-form
          :model="customer"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
           <el-form-item label="厂家名称" prop="name">
            <el-input v-model="customer.name" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="识别号" prop="code">
            <el-input v-model="customer.code" maxlength="3" placeholder="作为厂家管理员帐号，输入3位唯一编码"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="orgpassword">
            <el-input
              v-model="customer.orgpassword"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认" prop="password2">
            <el-input
              v-model="customer.password2"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
            <!-- <el-form-item label="手机号" prop="mobile">
            <el-input v-model="customer.mobile" maxlength="11"></el-input>
          </el-form-item>
            <el-form-item label="联系人" prop="person">
            <el-input v-model="customer.person" maxlength="5"></el-input>
          </el-form-item> -->
            <el-form-item label="所在城市" prop="city">
            <el-input v-model="customer.city" maxlength="7" placeholder="仅填写城市名称，如“杭州”"></el-input>
          </el-form-item>
           <el-form-item label="领科ID" prop="linksid">
            <el-input v-model="customer.linksid" maxlength="45" placeholder="领科系统编号"></el-input>
          </el-form-item>
           <el-form-item label="LOGO图片" prop="logo">
             <el-upload 
            style="text-align:left"
              class="avatar-uploader"
              name="upload"
              action="http://localhost:8000/resource/upload?isauth=0&type=2&program_type=BASE&filename="
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img  v-if="customer.logo" :src="'https://resource.mibee.cn/resource/' + customer.logo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>  
          <el-button  v-if="customer.logo" type="text" @click="customer.logo=''">删除LOGO</el-button>  
          </el-form-item>
            <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="createUser()">创建</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'CreateUser',
  data () {
    var codeCheck = (tule, value, callback) => {
      if (value && value.indexOf('@') >= 0) {
        callback(new Error('识别号中不能包含特殊符号'))
      } else if (value && value.length != 3) {
        callback(new Error('识别号位数不正确'))
      } else {
        callback()
      }
    }
    var mobileCheck = (tule, value, callback) => {
      if (value && (value.length != 11 || value[0] != 1)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var passwordCheck = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    var password2Check = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else if (value !== this.customer.orgpassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      customer: {
        name: '',
        mobile: '',
        password: '',
        orgpassword: '',
        password2: '',
        username: '',
        person:'',
        parentid: '',
        city: '',
        logo:'',
        linksid:''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入识别号', trigger: 'blur' },
          { validator: codeCheck, trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: mobileCheck, trigger: 'blur' }
        ],
        orgpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: password2Check, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
     handleAvatarSuccess(response) {
      this.customer.logo = response.uuid;
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    createUser () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          self.customer.password = hex_md5(self.customer.orgpassword)
          self.customer.orgpassword = ''
          self.customer.password2 = ''
          Vue.axios
            .post('/factory/add',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '厂家创建成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
                self.disabled = false
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Factory/Add.vue